module.exports = __webpack_public_path__ + "static/media/pause-circle.9010e2b1.svg";